import { render, staticRenderFns } from "./PerustietoTooltip.vue?vue&type=template&id=30efb4f3&"
import script from "./PerustietoTooltip.vue?vue&type=script&lang=js&"
export * from "./PerustietoTooltip.vue?vue&type=script&lang=js&"
import style0 from "./PerustietoTooltip.vue?vue&type=style&index=0&id=30efb4f3&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30efb4f3')) {
      api.createRecord('30efb4f3', component.options)
    } else {
      api.reload('30efb4f3', component.options)
    }
    module.hot.accept("./PerustietoTooltip.vue?vue&type=template&id=30efb4f3&", function () {
      api.rerender('30efb4f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PerustietoTooltip.vue"
export default component.exports